import { AfterContentInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UsuarioService } from 'src/app/core/services/usuario/usuario.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

declare var $: any;

@Component({
  selector: 'app-header-component',
  templateUrl: './header-component.component.html',
  styleUrls: ['./header-component.component.scss']
})
export class HeaderComponentComponent implements OnInit,AfterContentInit {
  @Input() title;
  @Input() ot;
  @Input() estado;
  @Input() score :any = "-";
  @Input() mission_id;
  @Input() botonFinalizar;

  private _esComplete: boolean = false;

  @Input() set esComplete(value: boolean) {
    this._esComplete = value;
    setTimeout(() => {
      $('.ui.dropdown').dropdown();
    }, 0);
  }

  get esComplete(): boolean {
    return this._esComplete;
  }
  html: string;
  @Output() accionDescargar: EventEmitter<boolean> = new EventEmitter<boolean>();
  puedeDescargar: boolean = true
  constructor(private cd: ChangeDetectorRef, public snackBar: MatSnackBar, private router: Router, private routerActivated: ActivatedRoute, private usuarioServices: UsuarioService) {

  }
  ngAfterContentInit(): void {
      $('.ui.dropdown').dropdown();
  }

  ngOnInit(): void {
    this.puedeDescargar = this.usuarioServices.hasRole();
  }

  copyURL() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = document.location.href;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.mensaje('Link copiado!', '')
  }

  descargarPDF() {
    this.accionDescargar.emit(true);
    $('.dropdown.icon').hide();
    $('.title').addClass('active')
    $('.content').addClass('active')
    $("#spinner").css("display", "block");
    $('.no-pdf-cell').addClass('none');
    $('.content.active > .container-panel').addClass('transition visible')


    if (this.title =='Evaluación completa') {
      console.log("es completo")
      this.html = (document.getElementById("DATA-COMPLETE-PDF")?.innerHTML);
    } else {
      console.log(" no es completo")
      this.html = (document.getElementById("DATA-PDF")?.innerHTML);
    }
    this.html =(this.html) ?  this.html?.replace('styled accordion', '') : " ";
    this.usuarioServices.generarPDF(this.html, this.title, this.estado, this.score).subscribe(data => {
      this.accionDescargar.emit(false);
      $('.dropdown.icon').show();
      $("#spinner").css("display", "none");
      $('.no-pdf').removeClass('none');
      $('.no-pdf-flex').removeClass('none');
      $('.no-pdf-cell').removeClass('none');
      $('.title').removeClass('active')
      $('.content').removeClass('active')
      this.mensaje('PDF listo!', '');
      this.downloadFile(data.body, this.title + "-" + this.ot + '.pdf')
    });
  }
  downloadFile(blob, fileName) {
    const link = document.createElement('a');
    this.blobToBase64(blob, (base64) => {
      link.href = base64;
      link.download = fileName;
      link.click();
      window.close()

    });
  };

  blobToBase64(blob, callback) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result;
      callback(base64);
    };
    reader.readAsDataURL(blob);

  };

  descargarLogs() {
    $("#spinner-logs").css("display", "block");
    let missionId = this.routerActivated.snapshot.params.mission;
    if (this.title == null) this.title = this.routerActivated.snapshot.params.instruction;

    this.usuarioServices.getLogs({ missionId, activity: this.title }).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = "LOGS - " + this.title + "-" + this.ot + '.txt';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      $("#spinner-logs").css("display", "none");

    });




  }
  mensaje(message, action) {
    this.snackBar.open(message, action, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: ['gray-snackbar'],
    });
  }


  finalizar() {

    const esInvalido = (this.estado != 'Completo');

    if (esInvalido) {
      console.warn("Intento de finalización no autorizado o condiciones no cumplidas.");
      return;
    }
    ($('#finalizacionModal') as any).modal('show');

  }
  cerrarModal() {
    const modal = document.getElementById('finalizacionModal');

    if (modal) {
      modal.classList.remove('visible', 'active');

      modal.style.setProperty('display', 'none', 'important');
    }

    const dimmer = document.querySelector('.ui.dimmer.modals.page');
    if (dimmer) {
      dimmer.classList.remove('visible', 'active');
      (dimmer as HTMLElement).style.setProperty('display', 'none', 'important');
    }
  }
  confirmarFinalizar() {

    // Forzamos a Angular a renderizar el cambio
    this.cd.detectChanges();
    this.usuarioServices.finish(this.mission_id).subscribe(
      res => {
        this.snackBar.open(res.result, 'x', {
          duration: 6500,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['green-snackbar'],
        });
        this.estado = 'Finalizado';
        this.cerrarModal();
      },
      error => {
        this.snackBar.open("La misión no se pudo finalizar correctamente", 'x', {
          duration: 6500,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['red-snackbar'],
        });
      }
    );
  }
}


